import actionTypes from "../../actions/actionTypes";
import updateObject from "../../../utils/updateObject";

const initialState = {
  countries: [],
  fetching: true,
  error: null,
  estimatedCountryIsoCode: "ES"
};

const fetchCountries = (state, action) => {
  return updateObject(state, {
    countries: [],
    fetching: true,
    error: null,
    estimatedCountryIsoCode: initialState.estimatedCountryIsoCode
  });
};

const fetchCountriesOk = (state, action) => {
  return updateObject(state, {
    countries: action.list,
    fetching: false,
    error: null,
    estimatedCountryIsoCode: action.estimatedCountryIsoCode
  });
};

const fetchCountriesError = (state, action) => {
  return updateObject(state, {
    countries: [],
    fetching: false,
    error: action.error,
    estimatedCountryIsoCode: initialState.estimatedCountryIsoCode
  });
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.geo.FETCH_COUNTRIES:
      return fetchCountries(state, action);
    case actionTypes.geo.FETCH_COUNTRIES_OK:
      return fetchCountriesOk(state, action);
    case actionTypes.geo.FETCH_COUNTRIES_ERROR:
      return fetchCountriesError(state, action);
    default:
      return state;
  }
}
